// This is the list of Modus that are allowed to be called even when the authStore is not logged in

export const allowedModus = [
  'einloggen',
  'rucksetzen',
  'validatePasswordResetCode',
  'passwortzuruck',
  'ping',
  'logout',
]
